// extracted by mini-css-extract-plugin
export default {"primaryButton":"PrimaryButton_primaryButton__gPylG","link":"PrimaryButton_link__fYs1g","goToImage":"PrimaryButton_goToImage__B2fvQ","isDisabled":"PrimaryButton_isDisabled__B3prU"};